import { Menu, MenuItem } from '@material-ui/core'
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined'
import ShareOutlinedIcon from '@material-ui/icons/ShareOutlined'
import { useState } from 'react'
import { Link } from 'react-router-dom'

import { ShareProjectModal } from '@/components/share-project-modal'
import { useCompanies } from '@/hooks/use-companies'
import { routes } from '@/routes/config'

import { ProjectDTO } from '..'
import { useStyles } from './styles'

interface ProjectMenuProps {
  menu: HTMLElement | null
  selectedProject: ProjectDTO | null
  onCloseMenu: () => void
  clearSelectedProject: () => void
}

export function ProjectMenu({
  menu,
  selectedProject,
  onCloseMenu,
  clearSelectedProject,
}: ProjectMenuProps) {
  const classes = useStyles()

  const [showShareProjectModal, setShowShareProjectModal] = useState(false)

  const { permissions } = useCompanies()

  const handleShareProject = () => {
    setShowShareProjectModal(true)
    onCloseMenu()
  }

  const handleCloseMenu = () => {
    onCloseMenu()
    clearSelectedProject()
  }

  return (
    <>
      <Menu
        anchorEl={menu}
        open={Boolean(menu)}
        onClose={handleCloseMenu}
        classes={{ paper: classes.menu }}
        elevation={3}
        transformOrigin={{
          vertical: -42,
          horizontal: 180,
        }}
      >
        <MenuItem
          disabled={!permissions?.updateUnities}
          component={Link}
          role='link'
          to={{ pathname: routes.ProjectEdit(selectedProject?.id) }}
        >
          <CreateOutlinedIcon fontSize='small' />
          Editar Projeto
        </MenuItem>
        {!permissions?.WeedAccess && (
          <MenuItem
            disabled={!permissions?.shareUnit}
            onClick={handleShareProject}
          >
            <ShareOutlinedIcon fontSize='small' /> Compartilhar Projeto
          </MenuItem>
        )}
      </Menu>

      <ShareProjectModal
        project={selectedProject!}
        open={showShareProjectModal}
        onClose={() => {
          setShowShareProjectModal(false)
          clearSelectedProject()
        }}
      />
    </>
  )
}
